import { ReactElement } from "react";
import { MetricsDashboardGraphType } from "../../../__generated__/api";
import PieChart from "./PieChart";
import CountChart from "./Count";
import Table from "./Table";
import TimeSeries from "./TimeSeries";

import { GraphProps } from "./base";

const COMPONENT_TO_TYPE: Record<string, (settings: GraphProps) => ReactElement> = {
    [MetricsDashboardGraphType.PieChart]: PieChart,
    [MetricsDashboardGraphType.Count]: CountChart,
    [MetricsDashboardGraphType.Table]: Table,
    [MetricsDashboardGraphType.TimeSeries]: TimeSeries,
};
export default COMPONENT_TO_TYPE;
